import React from "react";
var __jsx = React.createElement;
import PropTypes from "prop-types";
import { ELSLink } from "../elsevier/Link/Link";

/* eslint no-nested-ternary: "off", no-param-reassign: "off", no-useless-concat: "off" */
var OutwardIcon = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 78 128",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 36h57.07L1.57 95.5l7.07 7.08L68 43.22V100h10V26H4z"
}));

/**
 * Build an outward link
 * @param href
 * @param icon
 * @param children
 * @returns
 */
export var EVOutwardLink = function EVOutwardLink(_ref) {
  var href = _ref.href,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? true : _ref$icon,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ELSLink, {
    href: href,
    target: "_blank",
    rel: "noreferrer",
    className: "es-link__blue--16-font"
  }, /*#__PURE__*/React.createElement("span", {
    className: "es-link__text"
  }, children), icon && /*#__PURE__*/React.createElement("span", {
    className: "es-link__icon"
  }, /*#__PURE__*/React.createElement(OutwardIcon, null)));
};

// Get the EV beta URL.  While the new site is in beta mode, links should be prefixed
// with current EV env URL instead of "/" to ensure routing goes outside of the Next router
var betaMode = process.env.NEXT_PUBLIC_BETA_MODE === "true";
export function buildBetaBaseURL() {
  return betaMode ? process.env.NEXT_PUBLIC_BASE_URL ? process.env.NEXT_PUBLIC_BASE_URL : typeof window !== "undefined" ? "".concat(window.location.protocol, "//").concat(window.location.host) : "www.engineeringvillage.com" : "";
}
export function buildBaseUrl() {
  if (typeof window !== "undefined") {
    return "".concat(window.location.protocol, "//").concat(window.location.hostname);
  }
  return "/";
}
export var SearchTypes = ["Quick", "Expert", "Thesaurus"];
export var InspecAnalyticsType = new Map([["classificationCode", "cc"], ["controlledTerm", "ct"]]);

// validates & encodes parameter
// stripts out html tags if they are in the param
function validateAndEncodeParam(param) {
  var holdValue = param;
  if (holdValue) {
    holdValue = holdValue.toString().replace(/(<([^>]+)>)/gi, "");
    holdValue = holdValue.toString().replace(/^\*/, "");
  }
  return holdValue ? encodeURIComponent(holdValue) : "";
}

// Returns cited by link to display cited by results when clicked
// /search/submit.url?CID=quickSearchCitationFormat&implicit=true&usageOrigin=patentrefs
// &searchWord1=US10717669&section1=PCI&database=16826368&yearselect=yearrange
// &searchtype=Quick&CITEDBYFLAG=yes&sort=yr
export var buildCitedByUrl = function buildCitedByUrl(searchWord1, pci, database, usageOrigin, searchtype, cidPrefix) {
  return (
    // Uses same domain as running app
    "".concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_ENDPOINT, "?CID=").concat(cidPrefix, "CitationFormat&implicit=true&usageOrigin=").concat(validateAndEncodeParam(usageOrigin)) + "&searchWord1=".concat(validateAndEncodeParam(searchWord1), "&section1=").concat(validateAndEncodeParam(pci)) + "&database=".concat(validateAndEncodeParam(database), "&yearselect=yearrange&searchtype=").concat(searchtype, "&CITEDBYFLAG=yes&sort=yr")
  );
};

// Returns cited by link to display cited by results when clicked
// /search/submit.url?CID=quickSearchCitationFormat&implicit=true&usageOrigin=patentrefs
// &searchWord1=US10717669&section1=PCI&database=16826368&yearselect=yearrange
// &searchtype=Quick&CITEDBYFLAG=yes&sort=yr&angularReq=true&isFullJsonResult=true

// search/submit.url?CID=quickSearchCitationFormat&implicit=true&usageOrigin=patentrefs
// &searchWord1=US20180116607&section1=PCI&database=16826368&yearselect=yearrange
// &searchtype=Quick&CITEDBYFLAG=yes&sort=yr%20%20%20%20%20%20%20%20%20%20%20
// &angularReq=true&isFullJsonResult=true
// search/submit.url?CID=quickSearchCitationFormat&implicit=true&usageOrigin=patentrefs&searchWord1=US20170209053&section1=PCI&database=16826368&yearselect=yearrange&searchtype=Quick&CITEDBYFLAG=yes&sort=yr%20%20%20%20%20%20%20%20%20%20%20&angularReq=true&isFullJsonResult=true
export var buildCitedByFrameUrl = function buildCitedByFrameUrl(searchWord1, pci, database, usageOrigin, searchtype, cidPrefix) {
  return (
    // Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_ENDPOINT, "?CID=").concat(cidPrefix, "CitationFormat&implicit=true&usageOrigin=").concat(validateAndEncodeParam(usageOrigin)) + "&searchWord1=".concat(validateAndEncodeParam(searchWord1), "&section1=").concat(validateAndEncodeParam(pci)) + "&database=".concat(validateAndEncodeParam(database), "&yearselect=yearrange&searchtype=").concat(searchtype, "&CITEDBYFLAG=yes&sort=yr")
  );
};

/// scopus/citedby.url?isbn=&amp;issn=1476-1122&amp;docId=cpx_765291103c24cbae5M531819255120119&amp;usageZone=toolsinscopus&amp;usageOrigin=recordpage&amp;origin=record&amp;eid=2-s2.0-17644387736
export var buildCitedByScopusUrl = function buildCitedByScopusUrl(isbn, issn, docId, usageZone, usageOrigin, origin, eid, docType) {
  return "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_SCOPUS_CITED_URL_ENDPOINT, "?isbn=").concat(validateAndEncodeParam(isbn), "&issn=").concat(validateAndEncodeParam(issn)) + "&docId=".concat(validateAndEncodeParam(docId), "&usageZone=").concat(validateAndEncodeParam(usageZone), "&usageOrigin=").concat(validateAndEncodeParam(usageOrigin)) + "&origin=".concat(validateAndEncodeParam(origin), "&eid=").concat(validateAndEncodeParam(eid), "&docType=").concat(validateAndEncodeParam(docType));
};

// Returns url for full text document
// /search/results/fulltext.url?docIndex=1&docID=upt_M327d45d1739098a30089710178163190
// https://www.engineeringvillage.com/search/results/fulltext.url?docIndex=1&docID=cpx_2887970&usageOrigin=recordpage&usageZone=fulltexttop
// &usageOrigin=patentrefs&usageZone=resultslist
export var buildFullTextUrl = function buildFullTextUrl(docId, docIndex, usageOrigin, usageZone, docType) {
  return (
    // Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_FULLTEXT_ENDPOINT, "?docIndex=").concat(validateAndEncodeParam(docIndex), "&docID=").concat(validateAndEncodeParam(docId)) + "&usageOrigin=".concat(validateAndEncodeParam(usageOrigin), "&usageZone=").concat(validateAndEncodeParam(usageZone), "&docType=").concat(validateAndEncodeParam(docType))
  );
};

//   href={
// "https://www.engineeringvillage.com/delivery/download/" + requestBody.outputLocation + ".url?usageZone=oneclick&downloadformat=" + requestBody.downloadformat.toLowerCase() +
// "&filenameprefix=Engineering_Village&clearBasket=true&database=cpx&displayformat=abstract&docidlist=" +  requestBody.docidlist +
// "&handlelist=0&usageOrigin=recordpage&summary=false"
export var buildDownloadDeliveryUrl = function buildDownloadDeliveryUrl(outputLocation, usageZone, downloadformat, database, displayformat, docidlist, usageOrigin, filenamePrefix) {
  // Uses same domain as running app
  var holdFilenamePrefix = filenamePrefix || "Engineering_Village";
  var downloadUrl = "";
  if (outputLocation === "dropbox") {
    downloadUrl = "&dropBoxDownloadUrl=".concat(validateAndEncodeParam("/delivery/download/submit.url?usageZone=oneclick&downloadMedium=dropbox&downloadformat=".concat(downloadformat, "&displayformat=").concat(displayformat, "&docidlist=").concat(docidlist, "&filenameprefix=").concat(holdFilenamePrefix)));
  } else if (outputLocation === "mypc") {
    outputLocation = "submit";
  }
  return "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_DELIVERY_DOWNLOAD_ENDPOINT).concat(validateAndEncodeParam(outputLocation), ".url?usageZone=").concat(validateAndEncodeParam(usageZone)) + "&downloadformat=".concat(validateAndEncodeParam(downloadformat), "&filenameprefix=").concat(holdFilenamePrefix, "&clearBasket=true") + "&database=".concat(validateAndEncodeParam(database), "&displayformat=").concat(validateAndEncodeParam(displayformat), "&docidlist=").concat(validateAndEncodeParam(docidlist)) + "&handlelist=0&usageOrigin=".concat(validateAndEncodeParam(usageOrigin), "&summary=false").concat(downloadUrl);
};

// var mendeleylink = "/mendeley/submit.url?usageZone=oneclick&usageOrigin="+usageOriginForOneClick+"&docId="+docid;
export var buildMendeleyUrl = function buildMendeleyUrl(usageZone, usageOrigin, docidlist) {
  return "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_MENDELEY_ENDPOINT, "?usageZone=").concat(validateAndEncodeParam(usageZone)) + "&usageOrigin=".concat(validateAndEncodeParam(usageOrigin), "&docId=").concat(validateAndEncodeParam(docidlist));
};

/*
			var refworksURL = "http://www.refworks.com/express/ExpressImport.asp?filter=Desktop+Biblio.+Mgt.+Software&vendor=Engineering+Village+2";
	     if (app.userSession.attributes.userProfile.userId) {
	        addParams += "&uid=" + app.userSession.attributes.userProfile.userId;
	      }

			url = "https://" + baseaddress
					+ "/delivery/download/refworks.url?downloadformat="
					+ downloadformat + "&timestamp=" + milli
					+ "&sessionid=" + sessionid
					+ '&database=' + databaseid
					+ '&usageZone=oneclick&usageOrigin=' + usageOriginForDelivery
					+ addParams;
          			window.open(refworksURL + "&url=" + escape(url),
*/
// export const buildRefworksUrl = (downloadformat, docid, usageOrigin, uid, sessionId) => {
//   // Uses same domain as running app
//   let url = validateAndEncodeParam(
//     `${buildBaseUrl()}/delivery/download/refworks.url?&downloadformat=${downloadformat}&timestamp=${new Date().getTime()}&sessionid=${sessionId}&usageZone=oneclick&usageOrigin=${usageOrigin}&clearBasket=true&displayformat=detailed` +
//       `&docidlist=${docid}`,
//   );
//   if (uid) {
//     url += validateAndEncodeParam(`&uid=${uid}`);
//   }
//   return `${process.env.NEXT_PUBLIC_LEGACY_REFWORKS_ENDPOINT}&url=${url}`;
// };

// Returns url for local holdings url
// "/search/results/localholdinglinks.url?docId=" + docid + "&issn="+snvalue + "&year="+year + "&url=" + finalUrl + "&position=" + position + "&referer=" + URLEncoder.encode(context.getRefererParam(), "UTF-8");
export var buildLocalHoldingsUrl = function buildLocalHoldingsUrl(docid, issn, year, url, position, referer, usageOrigin, usageZone, docIndex) {
  return "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_LOCALHOLDINGS_ENDPOINT, "?docId=").concat(validateAndEncodeParam(docid), "&issn=").concat(validateAndEncodeParam(issn)) + "&year=".concat(validateAndEncodeParam(year), "&url=").concat(validateAndEncodeParam(url), "&position=").concat(validateAndEncodeParam(position)) + "&referer=".concat(validateAndEncodeParam(referer), "&usageOrigin=").concat(validateAndEncodeParam(usageOrigin), "&usageZone=").concat(validateAndEncodeParam(usageZone)) + "&docIndex=".concat(validateAndEncodeParam(docIndex));
};

// returns the url to view all search history
export var buildSearchHistoryUrl = function buildSearchHistoryUrl() {
  return (// Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_HISTORY_ENDPOINT)
  );
};

// returns the url to the auth endpoint
export var buildAuthSigninEndpoint = function buildAuthSigninEndpoint() {
  return (// Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_AUTH_SIGNIN_ENDPOINT)
  );
};

// returns the url to the auth change org endpoint
export var buildAuthChangeOrganization = function buildAuthChangeOrganization() {
  return (// Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_AUTH_CHANGE_ORG)
  );
};

// returns the url to the auth logout
export var buildAuthLogout = function buildAuthLogout() {
  return (// Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_AUTH_LOGOUT)
  );
};

// returns the url to the auth settings
export var buildAuthSettings = function buildAuthSettings() {
  return (// Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_AUTH_SETTINGS)
  );
};

// returns the url to the auth settings
export var buildAuthFolderLink = function buildAuthFolderLink(folderId, usageOrigin, backUrl) {
  return (
    // Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_AUTH_FOLDER, "?folderid=").concat(validateAndEncodeParam(folderId)) + "&usageOrigin=".concat(validateAndEncodeParam(usageOrigin), "&backurl=").concat(validateAndEncodeParam(backUrl))
  );
};

// returns the url to the auth settings
export var buildBulletinsUrl = function buildBulletinsUrl() {
  return (// Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_BULLETIN_URL)
  );
};

// https://dev.engineeringvillage.com/personal/savesearch/display.url?usageOrigin=header&usageZone=savedsearchandalertlink
// Url used in the header
export var buildAlertPageUrl = function buildAlertPageUrl(usageOrigin, usageZone) {
  return (// Uses same domain as running app, usage info is consistent
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_ALERT_SAVED_SEARCHES, "?usageOrigin=").concat(validateAndEncodeParam(usageOrigin), "&usageZone=").concat(validateAndEncodeParam(usageZone))
  );
};

// Returns url for abstract via designated DB - database is joined with docid in the payload
// /search/doc/abstract.url?usageOrigin=patentrefs&usageZone=resultslist&pageType=quickSearch
// &searchtype=Quick&SEARCHID=fe67909e5b274ec0806f49b264b44600&format=quickSearchAbstractFormat
// &database=32768&docid=upt_M327d45d1739098a30089710178163190&tagscope=null&indivDoc=true
export var buildAbstractDBUrl = function buildAbstractDBUrl(searchId, database, docId, usageOrigin, usageZone, searchtype, pageType, format) {
  return (
    // Uses same domain as running app
    "/".concat(process.env.NEXT_PUBLIC_ABSTRACT_ENDPOINT, "?content=true&usageZone=").concat(validateAndEncodeParam(usageZone), "&pageType=").concat(pageType, "&searchtype=").concat(searchtype) + "&SEARCHID=".concat(validateAndEncodeParam(searchId), "&format=").concat(format) + "&database=".concat(validateAndEncodeParam(database), "&docid=").concat(validateAndEncodeParam(docId)) + "&usageOrigin=".concat(validateAndEncodeParam(usageOrigin))
  );
};

// Returns url for abstract document
// Returns url for abstract via designated DB - database is joined with docid in the payload
// /search/abstract/detailed.url?usageOrigin=nonpatentrefs&usageZone=resultslist&detailed=true&pageType=quickSearch
// &searchtype=Quick&SEARCHID=de598d629c6a4482a0550aa8cf0ad79a&docid=cpx_196680&database=1&indivDoc=true&format=quickSearchDetailedFormat
export var buildAbstractUrl = function buildAbstractUrl(searchId, docId, usageOrigin, usageZone, searchtype, pageType, format, indivDoc) {
  return (
    // Uses same domain as running app
    "".concat(process.env.NEXT_PUBLIC_ABSTRACT_ENDPOINT, "?usageOrigin=").concat(validateAndEncodeParam(usageOrigin), "&usageZone=").concat(validateAndEncodeParam(usageZone)) + "&detailed=true&pageType=".concat(pageType, "&searchtype=").concat(searchtype, "&SEARCHID=").concat(validateAndEncodeParam(searchId)) + "&docid=".concat(validateAndEncodeParam(docId), "&format=").concat(validateAndEncodeParam(format), "&indivDoc=").concat(validateAndEncodeParam(indivDoc))
  );
};

// Returns url for abstract document
// Returns url for abstract via designated DB - database is joined with docid in the payload
// /search/abstract/detailed.url?usageOrigin=nonpatentrefs&usageZone=resultslist&detailed=true&pageType=quickSearch
// &searchtype=Quick&SEARCHID=de598d629c6a4482a0550aa8cf0ad79a&docid=cpx_196680&database=1&indivDoc=true&format=quickSearchDetailedFormat
export var buildPreviewUrl = function buildPreviewUrl(searchId, docId, usageOrigin, usageZone, searchtype, docIndex, database) {
  return (
    // Uses same domain as running app
    "/search/results/preview.url?usageOrigin=".concat(validateAndEncodeParam(usageOrigin), "&usageZone=").concat(validateAndEncodeParam(usageZone)) + "&searchtype=".concat(searchtype, "&SEARCHID=").concat(validateAndEncodeParam(searchId)) + "&docid=".concat(validateAndEncodeParam(docId), "&docIndex=").concat(validateAndEncodeParam(docIndex), "&database=").concat(validateAndEncodeParam(database))
  );
};

// Returns the url for a classification code
// /search/submit.url?CID=quickSearchCitationFormat&implicit=true&usageOrigin=recordpage&searchtype=Quick&searchWord1={B3120J}&section1=CL&database=2&yearselect= yearrange &sort=yr" > B3120J</A> Magneto-acoustic, magnetoresistive, magnetostrictive and magnetostatic wave devices
export var buildClsCodeUrl = function buildClsCodeUrl(searchWord1, section1, database, usageOrigin, cidPrefix) {
  return (
    // Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_ENDPOINT, "?CID=").concat(cidPrefix, "CitationFormat&implicit=true&usageOrigin=").concat(validateAndEncodeParam(usageOrigin)) + "&searchWord1=".concat(validateAndEncodeParam(searchWord1), "&section1=").concat(validateAndEncodeParam(section1)) + "&database=".concat(validateAndEncodeParam(database), "&yearselect=yearrange&sort=yr")
  );
};

// Returns the url for a project number
// /search/submit.url?searchtype=Quick&searchWord1=%20R61DH&section1=CT&database=23129543&yearselect=yearrange&sort=yr
export var buildProjectNumUrl = function buildProjectNumUrl(searchWord1, section1, database) {
  return (
    // Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_ENDPOINT, "?searchtype=Quick") + "&searchWord1=".concat(validateAndEncodeParam(searchWord1), "&section1=").concat(validateAndEncodeParam(section1)) + "&database=".concat(validateAndEncodeParam(database), "&yearselect=yearrange&sort=yr")
  );
};

// Returns the url for linked terms
// /search/doc/enclongterms.url?searchid=53678c5fa62640ffb07512a92c660dc2&istag=ept_f7261713f1108617bM7e012061377553:2048&docid=ept_f7261713f1108617bM7e012061377553&timestamp=1631812769575
// searchid is not needed if istag is available
export var buildLinkedTermsUrl = function buildLinkedTermsUrl(docid, database) {
  return (
    // Uses same domain as running app
    "/".concat(process.env.NEXT_PUBLIC_ENCLONGTERMS_ENDPOINT, "?istag=").concat(validateAndEncodeParam(docid), ":").concat(validateAndEncodeParam(database)) + "&docid=".concat(validateAndEncodeParam(docid))
  );
};

// Returns the url for a terms search
// /search/submit.url?CID=quickSearchCitationFormat&implicit=true&usageOrigin=recordpage&searchtype=Quick&searchWord1={iron+alloys}&section1=CV&database=2&yearselect=%20yearrange%20&sort=yr
// Version search -
// /search/submit.url?CID=expertSearchCitationFormat&implicit=true&usageOrigin=standardrefs&searchtype=Expert&searchWord1=802.1Q*%20wn%20stdid&section1=st&database=1&yearselect=yearrange&sort=relevance
export var buildTermsUrl = function buildTermsUrl(searchWord1, section1, database, usageOrigin, cidPrefix, searchtype, implicit, yearselect, sort) {
  return (
    // Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_ENDPOINT, "?CID=").concat(cidPrefix, "CitationFormat&implicit=").concat(validateAndEncodeParam(implicit)) + "&usageOrigin=".concat(validateAndEncodeParam(usageOrigin), "&searchtype=").concat(searchtype, "&searchWord1=").concat(validateAndEncodeParam(searchWord1)) + "&section1=".concat(validateAndEncodeParam(section1), "&database=").concat(validateAndEncodeParam(database)) + "&yearselect=".concat(validateAndEncodeParam(yearselect), "&sort=").concat(validateAndEncodeParam(sort))
  );
};

// returns the url for an author search
// /scopus/author/details.url?isbn=&issn=1476-1122&docId=cpx_765291103c24cbae5M531819255120119&usageZone=toolsinscopus&usageOrigin=recordpage&origin=record&authorid=7004417558
export var buildAuthorUrl = function buildAuthorUrl(isbn, issn, docId, usageZone, usageOrigin, origin, authorid, docType) {
  return (
    // Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_AUTHOR_ENDPOINT, "?isbn=").concat(validateAndEncodeParam(isbn), "&issn=").concat(validateAndEncodeParam(issn), "&docId=").concat(validateAndEncodeParam(docId)) + "&usageZone=".concat(validateAndEncodeParam(usageZone), "&usageOrigin=").concat(validateAndEncodeParam(usageOrigin)) + "&origin=".concat(validateAndEncodeParam(origin), "&authorid=").concat(validateAndEncodeParam(authorid), "&docType=").concat(validateAndEncodeParam(docType))
  );
};

// Returns url for full text document
// /lindahall/auth.url?docid=cpx_M20ca493d1790f666f6aM657e10178163190&database=cpx
export var buildLindaHallUrl = function buildLindaHallUrl(docId, database) {
  return (// Uses same domain as running app
    "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LINDAHALL_ENDPOINT, "?docid=").concat(validateAndEncodeParam(docId), "&database=").concat(validateAndEncodeParam(database))
  );
};

/// *"milink": "\n\n\t\t<A CLASS=\"SpLink\"\n\t\t\t title=\"Search Material Identity Number\" alt=\"Search Material Identity Number\"\n\t\t\t\t\t\thref=\"/search/submit.url?CID=quickSearchCitationFormat&implicit=true&usageOrigin=recordpage&searchtype=Quick&searchWord1={GB49-2021-024}&section1=MI&database=2&yearselect=\n\t\t\t\t\tyearrange\n\t\t\t\t&sort=yr\"\n\t\t\t\t\t>\n\t\t\tGB49-2021-024</A>\n\t",*/
export var buildMIUrl = function buildMIUrl(cidPrefix, usageOrigin, searchtype, searchWord1, database) {
  return "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_ENDPOINT, "?CID=").concat(cidPrefix, "CitationFormat&implicit=true&usageOrigin=").concat(validateAndEncodeParam(usageOrigin)) + "&searchWord1={".concat(validateAndEncodeParam(searchWord1), "}&section1=MI") + "&database=".concat(validateAndEncodeParam(database), "&yearselect=yearrange&searchtype=").concat(searchtype, "&sort=yr");
};

// https://evwebreact.engineeringvillage.com/search/submit.url?CID=quickSearchCitationFormat&implicit=true&usageOrigin=recordpage&searchtype=Quick&searchWord1={28213+Styrene+Resins}&section1=IC&database=256&yearselect=%20yearrange%20&sort=yr
// If Expert is passed as the search type, searchWord1 becomes something like "{Brown, Joe} WN AU" and section1 is not passed on the URL
// If Quick is passed as the search type, searchWord1 is like "{Brown, Joe}" and section1 is set to AU
export var buildSpecificSearchUrl = function buildSpecificSearchUrl(cidPrefix, usageOrigin, searchtype, searchWord1, database, section1, category, sortType, overrideAddSection1, noCurlyBraces) {
  var holdCategory = category ? "&category=".concat(category) : "";
  var holdSort = sortType || "yr";
  searchtype = searchtype || "Expert";
  var holdSearchWord1 = validateAndEncodeParam(searchWord1);
  holdSearchWord1 = (noCurlyBraces ? "" : "{") + holdSearchWord1 + (noCurlyBraces ? "" : "}");
  var holdSection1 = searchtype === "Quick" || overrideAddSection1 ? "&section1=".concat(section1) : "";
  if (searchtype === "Expert" && !overrideAddSection1) {
    holdSearchWord1 += validateAndEncodeParam(" WN ".concat(section1));
  }
  return "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_ENDPOINT, "?CID=").concat(cidPrefix, "CitationFormat&implicit=true&usageOrigin=").concat(validateAndEncodeParam(usageOrigin)) + "&searchWord1=".concat(holdSearchWord1).concat(holdSection1).concat(holdCategory, "&database=").concat(validateAndEncodeParam(database), "&yearselect=yearrange&searchtype=").concat(searchtype, "&sort=").concat(holdSort);
};

// https://dev2.engineeringvillage.com/search/results/expert.url?SEARCHID=ffe9db3e95de412584bd3451e5bd64c8&COUNT=1&database=1&searchtype=Expert&usageOrigin=searchhistory&usageZone=searcheslist
export var buildExpertSearchUrl = function buildExpertSearchUrl(SEARCHID, COUNT, database, searchtype, usageOrigin, usageZone) {
  var baseHref = searchtype === "Quick" ? "/search/quick.url" : "/search/expert.url";
  return "".concat(buildBaseUrl() + baseHref, "?SEARCHID=").concat(validateAndEncodeParam(SEARCHID)) + "&usageOrigin=".concat(validateAndEncodeParam(usageOrigin), "&COUNT=").concat(validateAndEncodeParam(COUNT), "&usageZone=").concat(usageZone);
};

// https://www.engineeringvillage.com/search/results/dedup.url?CID=dedup&SEARCHID=bcefa0a3d381499d9dc1fc45d47e4eea&database=23129543&fieldpref=4&dbpref=cpx&usageOrigin=searchresults&usageZone=dedupform
export var buildDedupSearchUrl = function buildDedupSearchUrl(cid, searchid, database, fieldpref, dbpref, usageOrigin, usageZone) {
  return "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_DEDUP_RESULTS, "?CID=").concat(validateAndEncodeParam(cid)) + "&SEARCHID=".concat(validateAndEncodeParam(searchid), "&database=").concat(validateAndEncodeParam(database)) + "&fieldpref=".concat(validateAndEncodeParam(fieldpref), "&dbpref=").concat(validateAndEncodeParam(dbpref)) + "&usageOrigin=".concat(validateAndEncodeParam(usageOrigin), "&usageZone=").concat(validateAndEncodeParam(usageZone));
};

// https://www.engineeringvillage.com/selected/citation.url?usageOrigin=header&usageZone=selectedrecordslink
export var buildSelectedUrl = function buildSelectedUrl(usageOrigin, usageZone) {
  return "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_SELECTED_URL, "?usageOrigin=").concat(validateAndEncodeParam(usageOrigin)) + "&usageZone=".concat(validateAndEncodeParam(usageZone));
};
export var buildRelatedDocsViewAllSearchUrl = function buildRelatedDocsViewAllSearchUrl(cidPrefix, usageOrigin, usageZone, searchtype, searchWord1, database, cacheKey, docNavType) {
  var docNavTypeString = docNavType ? "&docNavType=".concat(validateAndEncodeParam(docNavType)) : "";
  return "".concat(buildBaseUrl()).concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_ENDPOINT, "?CID=").concat(cidPrefix, "CitationFormat&implicit=true&usageOrigin=").concat(validateAndEncodeParam(usageOrigin)) + "&searchWord1=".concat(validateAndEncodeParam(searchWord1), "&usageZone=").concat(validateAndEncodeParam(usageZone)) + "&database=".concat(validateAndEncodeParam(database), "&yearselect=yearrange&searchtype=").concat(searchtype, "&sort=relevance") + "&cacheKey=".concat(validateAndEncodeParam(cacheKey)).concat(docNavTypeString);
};

// https://www.engineeringvillage.com/search/inspecanalytics/display.url?ct=5718
// https://www.engineeringvillage.com/search/inspecanalytics/display.url?cc=1867
export var buildInspecAnalyticsUrl = function buildInspecAnalyticsUrl(inspecAnalyticType, inspecAnalyticValue) {
  var iaType = InspecAnalyticsType.get(inspecAnalyticType);
  return iaType ? "".concat(process.env.NEXT_PUBLIC_INSPEC_ANALYTICS_CC_CT_ENDPOINT, "?").concat(iaType, "=").concat(inspecAnalyticValue) : "";
};

// https://dev.engineeringvillage.com/rest/lookup/inspec/controlledTerm?value="
export var buildLookupInspecUrl = function buildLookupInspecUrl(lookUpType, value) {
  return "".concat(process.env.NEXT_PUBLIC_INSPEC_LOOKUP_ENDPOINT, "/").concat(validateAndEncodeParam(lookUpType), "?value=").concat(validateAndEncodeParam(value));
};

// https://www.engineeringvillage.com/search/submit.url?CID=expertSearchCitationFormat&implicit=true&usageOrigin=morelikethis&usageZone=panelviewall&searchtype=Expert&searchWord1=test&database=23129543&yearselect=yearrange&sort=relevance&cacheKey=prodmltv5_cpx_2887970_23129543&docNavType=ja

export var buildFieldSearchUrl = function buildFieldSearchUrl(_ref2) {
  var _ref2$searchtype = _ref2.searchtype,
    searchtype = _ref2$searchtype === void 0 ? "Quick" : _ref2$searchtype,
    field = _ref2.field,
    value = _ref2.value,
    database = _ref2.database,
    _ref2$origin = _ref2.origin,
    origin = _ref2$origin === void 0 ? "" : _ref2$origin,
    _ref2$category = _ref2.category,
    category = _ref2$category === void 0 ? "" : _ref2$category,
    _ref2$implicit = _ref2.implicit,
    implicit = _ref2$implicit === void 0 ? true : _ref2$implicit;
  // TODO - handle empty field, value, database
  var searchparams = searchtype === "Quick" ? "&section1=".concat(field, "&searchWord1=").concat(encodeURIComponent("{".concat(value, "}"))) : "&searchWord1=".concat(encodeURIComponent("{".concat(value, "}") + " wn ".concat(field)));
  return "".concat(process.env.NEXT_PUBLIC_LEGACY_SEARCH_ENDPOINT, "?implicit=").concat(implicit, "&searchtype=").concat(searchtype).concat(searchparams).concat(database ? "&database=".concat(database) : "").concat(category ? "&category=".concat(category) : "", "&usageOrigin=").concat(origin);
};
buildFieldSearchUrl.propTypes = {
  /**
   Set the unique identifier for the component
  */
  searchtype: PropTypes.oneOf(SearchTypes),
  field: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  database: PropTypes.string,
  implicit: PropTypes.bool,
  attributes: PropTypes.object
};
buildFieldSearchUrl.defaultProps = {
  searchtype: "Quick",
  implicit: true,
  attributes: {}
};